import { ModerationType } from "shared/pages/teams/const/ModerationTypes";
import { AppTester } from "supporting";
import { useBreakpoint, useIsMobile, useToasts } from "@brg/ui";
import { SlideNavigation } from "shared/components/slideNavigation";
import { useEncodedStateFilter } from "shared/components/Filters/EncodedStateFilterProvider";
import useQueryState from "shared/hooks/useQueryState";
import { useMemo } from "react";
import { useTranslation } from "react-i18next";

const TeamLargeTabs = ({
    team,
    categoryList,
    tabList,
    currentCategory,
    currentTab,
    tabsRaw
}: any) => {
    const { setSorting } = useEncodedStateFilter();
    const isMobile = useIsMobile();
    const [, setQueryParams] = useQueryState();
    const { t } = useTranslation();
    const toasts = useToasts();
    const {
        contextName: context,
        isLargeTabs,
        categories,
    } = team;

    const is430 = useBreakpoint(470);
    const isLectureMedia = AppTester.isLectureMediiia();
    const isAgeytomesh = useMemo(() => (context === 'ageytomesh'), [context])
    const hasCategories = !!categories?.length;

    const titleIsTabs = (isLargeTabs || hasCategories);

    const setCurrentTab = (value: string) => {

        if (isLectureMedia && isMobile) {
            setSorting(1)
        } else if (isLectureMedia) {
            setSorting(1)
            setQueryParams({ tab: value }, { replace: true })
        } else {
            setQueryParams({ tab: value }, { replace: true })
        }
    }

    const setCurrentCategory = (value: string) => {
        const currentTab = tabsRaw.find((x: any) => {
            return x.category === value && x.isMain;
        });
        setQueryParams({ category: value, tab: currentTab?.path || null }, { replace: true })
    }

    const shouldRenderTabs = !is430;

    if (!(titleIsTabs && shouldRenderTabs)) {
        return null;
    }

    if (!isAgeytomesh) {
        return (
            <SlideNavigation
                activeIndexKey={hasCategories ? currentCategory : currentTab}
                onChange={(tab) => {
                    if (hasCategories) {
                        if (tab === 'quiz') {
                            toasts.error(t('in_develop'));
                            return;
                        }
                        setCurrentCategory(tab);
                        return;
                    }
                    setCurrentTab(tab as string);
                    setQueryParams({
                        tab
                    }, { replace: true });
                }}
                items={hasCategories ? categoryList : tabList}
                isLoading={false}
                isTitle
                dropdownWhiteTheme={team?.moderationType == ModerationType.LMS}
            />
        )
    }
};

export default TeamLargeTabs;import { ModerationType } from "shared/pages/teams/const/ModerationTypes";
import { AppTester } from "supporting";
import { useBreakpoint, useIsMobile, useToasts } from "@brg/ui";
import { SlideNavigation } from "shared/components/slideNavigation";
import { useEncodedStateFilter } from "shared/components/Filters/EncodedStateFilterProvider";
import useQueryState from "shared/hooks/useQueryState";
import { useMemo } from "react";
import { useTranslation } from "react-i18next";

const TeamLargeTabs = ({
    team,
    categoryList,
    tabList,
    currentCategory,
    currentTab,
    tabsRaw
}: any) => {
    const { setSorting } = useEncodedStateFilter();
    const isMobile = useIsMobile();
    const [, setQueryParams] = useQueryState();
    const { t } = useTranslation();
    const toasts = useToasts();
    const {
        contextName: context,
        isLargeTabs,
        categories,
    } = team;

    const is430 = useBreakpoint(470);
    const isLectureMedia = AppTester.isLectureMediiia();
    const isAgeytomesh = useMemo(() => (context === 'ageytomesh'), [context])
    const hasCategories = !!categories?.length;

    const titleIsTabs = (isLargeTabs || hasCategories);

    const setCurrentTab = (value: string) => {

        if (isLectureMedia && isMobile) {
            setSorting(1)
        } else if (isLectureMedia) {
            setSorting(1)
            setQueryParams({ tab: value }, { replace: true })
        } else {
            setQueryParams({ tab: value }, { replace: true })
        }
    }

    const setCurrentCategory = (value: string) => {
        const currentTab = tabsRaw.find((x: any) => {
            return x.category === value && x.isMain;
        });
        setQueryParams({ category: value, tab: currentTab?.path || null }, { replace: true })
    }

    const shouldRenderTabs = !is430;

    if (!(titleIsTabs && shouldRenderTabs)) {
        return null;
    }

    if (!isAgeytomesh) {
        return (
            <SlideNavigation
                activeIndexKey={hasCategories ? currentCategory : currentTab}
                onChange={(tab) => {
                    if (hasCategories) {
                        if (tab === 'quiz') {
                            toasts.error(t('in_develop'));
                            return;
                        }
                        setCurrentCategory(tab);
                        return;
                    }
                    setCurrentTab(tab as string);
                    setQueryParams({
                        tab
                    }, { replace: true });
                }}
                items={hasCategories ? categoryList : tabList}
                isLoading={false}
                isTitle
                dropdownWhiteTheme={team?.moderationType == ModerationType.LMS}
            />
        )
    }
};

export default TeamLargeTabs;